import React from 'react';
import { Link } from 'react-router-dom';

const LandingPage = () => {
  return (
    <div className="landing-page">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="logo">
            <h1>Pebble</h1>
          </div>
          <nav className="nav">
            <Link to="/privacy" className="nav-link">Privacy</Link>
            <Link to="/terms" className="nav-link">Terms</Link>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-grid">
            <div className="hero-content">
              <h1 className="hero-title">Track Your Baby's Journey with Pebble</h1>
              <p className="hero-subtitle">
                The simple, secure way to monitor your baby's feeding, sleeping, diaper changes, and precious moments. 
                Built for parents, by parents.
              </p>
              <div className="hero-buttons">
                <a href="https://apps.apple.com/us/app/pebble-baby-tracker/id6743095630" className="btn btn-white">Download for iOS</a>
                {/* <a href="https://play.google.com/store/apps/details?id=com.pebble.baby" className="btn btn-outline">Download for Android</a> */}
              </div>
            </div>
            <div className="hero-image">
              <div className="phone-frame">
                <div className="phone-screen">
                  <img 
                    src="/app-preview.png" 
                    alt="Pebble App Preview" 
                    className="app-screenshot"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features">
        <div className="container">
          <h2 className="section-title">Everything You Need to Track</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">📸</div>
              <h3>Daily Photos</h3>
              <p>Capture your baby's growth with one beautiful photo per day. Watch them grow through time.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🍼</div>
              <h3>Feeding Tracker</h3>
              <p>Log breastfeeding sessions, bottle feeds, and solid foods. Keep track of feeding patterns.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">💤</div>
              <h3>Sleep Monitoring</h3>
              <p>Track sleep duration and patterns to understand your baby's sleep schedule.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👶</div>
              <h3>Diaper Changes</h3>
              <p>Monitor diaper changes and patterns to ensure your baby's health and comfort.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">🏆</div>
              <h3>Milestones</h3>
              <p>Celebrate and track important developmental milestones in your baby's journey.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon">👥</div>
              <h3>Family Sharing</h3>
              <p>Share your baby's progress with family members and caregivers securely.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Privacy Section */}
      <section className="privacy-section">
        <div className="container">
          <h2 className="section-title">Your Privacy Matters</h2>
          <div className="privacy-content">
            <div className="privacy-text">
              <h3>Your Photos Stay Private</h3>
              <p>
                We understand how precious your baby's photos are. That's why we never share, sell, or distribute 
                your personal photos. Your memories belong to you and your family, always.
              </p>
              <h3>Helpful Insights, Anonymous Data</h3>
              <p>
                To help all parents, we may use anonymized, aggregated data about feeding patterns, sleep schedules, 
                and developmental milestones to provide helpful insights like "babies at 6 months typically sleep 
                10-12 hours per night." Your individual data is never identifiable.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-section">
              <h3>Pebble</h3>
              <p>Making parenting a little easier, one day at a time.</p>
            </div>
            <div className="footer-section">
              <h4>Legal</h4>
              <Link to="/privacy" className="footer-link">Privacy Policy</Link>
              <Link to="/terms" className="footer-link">Terms of Service</Link>
            </div>
            <div className="footer-section">
              <h4>Support</h4>
              <a href="mailto:support@pebble.baby" className="footer-link">Contact Support</a>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2025 Pebble. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;